import React from 'react';

const CouponCutEffectIconLeft = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={5}
      height={40}
      viewBox='0 0 5 40'
      fill='none'
      {...props}
    >
      <path
        d='M5 5L-2.18557e-07 4.76837e-07L5 2.5828e-07L5 5Z'
        fill='#450B05'
      />
      <path d='M-2.18557e-07 10L5 5L5 15L-2.18557e-07 10Z' fill='#450B05' />
      <path d='M-2.18557e-07 20L5 15L5 25L-2.18557e-07 20Z' fill='#450B05' />
      <path d='M-2.18557e-07 30L5 25L5 35L-2.18557e-07 30Z' fill='#450B05' />
      <path d='M-2.18557e-07 40L5 35L5 45L-2.18557e-07 40Z' fill='#450B05' />
    </svg>
  );
};

export default CouponCutEffectIconLeft;
